import { render, staticRenderFns } from "./CtaMobile.vue?vue&type=template&id=52868610&scoped=true&"
import script from "./CtaMobile.vue?vue&type=script&lang=js&"
export * from "./CtaMobile.vue?vue&type=script&lang=js&"
import style0 from "./CtaMobile.vue?vue&type=style&index=0&id=52868610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52868610",
  null
  
)

export default component.exports